<div class="totalContainer">
  <div class="banner_bg">
    <div class="container">
      <h3 class="white">You Are Invited By : {{ userName }}</h3>
      <div class="banner_mid_box">
        <div class="row">
          <div class="col-lg-4">
            <div class="left_banner_box" data-aos="fade-right">
              Witness<br />
              <span>The Magic</span>
              <img
                src="{{
                  myLinksS3URL
                }}frontend/presentation6/images/arrow_one.png"
                alt="arrow"
                class="arrow_image"
              />
            </div>
            <br />
          </div>
          <div class="col-lg-8">
            <div class="right_box">
              <div class="right_box_face" data-aos="zoom-in">
                <img
                  src="{{
                    myLinksS3URL
                  }}frontend/presentation6/images/man_face.png"
                  alt="image"
                />
                <div class="banner_right_top_box">
                  <div class="video_image">
                    <a
                      href="#"
                      data-toggle="modal"
                      data-backdrop="static"
                      data-keyboard="false"
                      data-target="#myModal4"
                      ><img
                        src="{{
                          myLinksS3URL
                        }}frontend/presentation6/images/video_image.png"
                        alt="video"
                    /></a>
                  </div>
                  <div class="right_ex_box" data-aos="fade-down">
                    <div class="wifi_box">
                      <img
                        src="{{
                          myLinksS3URL
                        }}frontend/presentation6/images/wifi.png"
                        alt="image"
                      />
                      <div class="wifi_text">
                        Worldwide Priority Placement Available
                      </div>
                    </div>
                    <h1>Unleash Financial Freedom</h1>
                    <a
                      [routerLink]="'.'"
                      [queryParams]="{ reg: referralId }"
                      [fragment]="'regform'"
                    >
                      <div class="become_button">BECOME A FOUNDER NOW</div>
                    </a>
                  </div>
                </div>
              </div>
              <h5>
                Now Open in <span id="city">{{ city }}</span
                >, <span id="country">{{ country }}</span>
                <br />

                <input
                  type="hidden"
                  id="ipadress"
                  name="ipadress"
                  value="14.97.11.70, 192.180.30.233"
                />
                <input
                  type="hidden"
                  id="key"
                  name="key"
                  value="56e0d8aaef9f0c485ac454467477cbd3"
                />
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="sec_two">
    <div class="container">
      <div class="welcome_box" data-aos="fade-up">
        <h1>A technology based on artificial intelligence.</h1>

        <p>
          Witness global leaders taking part on a life changing journey! The
          financial freedom which you least expected to get, is finally
          launching. Digital success is reshaping the business dynamics. Zero
          risks is guaranteed.
        </p>

        <a
          [routerLink]="'.'"
          [queryParams]="{ reg: referralId }"
          [fragment]="'regform'"
          class="become_button_two"
        >
          BECOME A FOUNDER NOW
        </a>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-6">
          <div class="sec_two_left_box" data-aos="fade-right">
            <h1>Affiliate to Phenomenal Success</h1>
            <p>
              We invite you to have a look at the video and learn further about
              O-Founders
            </p>
            <h6>
              A meticulously crafted platform which aims at being the number 1
              Global business solution!
            </h6>
            <div class="clearfix"></div>
            <a
              [routerLink]="'.'"
              [queryParams]="{ reg: referralId }"
              [fragment]="'regform'"
              class="become_button_one"
            >
              BECOME A FOUNDER NOW
            </a>
          </div>
        </div>
        <div class="col-lg-6 col-md-6">
          <div class="sec_two_right_box" data-aos="zoom-in">
            <div class="sec_two_right_box_image">
              <img
                src="{{ myLinksS3URL }}frontend/presentation6/images/image.png"
                alt="image"
              />
            </div>
            <div class="sec_two_video_image">
              <a
                href="#"
                data-toggle="modal"
                data-backdrop="static"
                data-keyboard="false"
                data-target="#myModal1"
                ><img
                  src="{{
                    myLinksS3URL
                  }}frontend/presentation6/images/video_image.png"
                  alt="video"
              /></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="clearfix"></div>
  <div class="sec_three">
    <div class="sec_left_box" data-aos="fade-right">
      <img
        src="{{ myLinksS3URL }}frontend/presentation6/images/glob_icon.png"
        alt="icon"
      />
      <h1>Make your life worth living!</h1>
      <p>
        Develop a visionary mindset and watch the power of internet take charge
        on your future. We invite you to join us onboard.
      </p>
    </div>
    <div class="sec_right_box" data-aos="fade-left">
      <img
        src="{{ myLinksS3URL }}frontend/presentation6/images/search_icon.png"
        alt="icon"
      />
      <h1>We guarantee you 100% lifetime money back</h1>
      <div class="sec_right_box_bottom">
        <ul>
          <li><a>An Upgraded Marketing Automation </a></li>
          <li><a>Guaranteed Web Traffic </a></li>
          <li><a>Instant Earnings </a></li>
        </ul>
      </div>
    </div>
  </div>
  <div class="sec_two">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 col-md-6">
          <div class="sec_two_right_box" data-aos="zoom-in">
            <div class="sec_two_right_box_image_one">
              <img
                src="{{ myLinksS3URL }}frontend/presentation6/images/image.png"
                alt="image"
              />
            </div>
            <div class="sec_two_video_image_one">
              <a
                href="#"
                data-toggle="modal"
                data-backdrop="static"
                data-keyboard="false"
                data-target="#myModal2"
                ><img
                  src="{{
                    myLinksS3URL
                  }}frontend/presentation6/images/video_image.png"
                  alt="video"
              /></a>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-6">
          <div class="sec_two_left_box" data-aos="fade-left">
            <h1>
              Decoding Intelligent Business creation,Crafted from over Two
              decades of experience!
            </h1>
            <div class="clearfix"></div>
            <div class="sec_three_bottom_box">
              <ul>
                <li><a>No Requirements</a></li>
                <li><a>No Recruiting</a></li>
                <li><a>No Auto-ship</a></li>
                <li><a>No Monthly Fees</a></li>
              </ul>
            </div>
            <a
              [routerLink]="'.'"
              [queryParams]="{ reg: referralId }"
              [fragment]="'regform'"
            >
              <div class="become_button_one">BECOME A FOUNDER NOW</div>
            </a>
          </div>
        </div>
      </div>
      <div class="option_box">
        <div class="wifi_two_image">
          <img
            src="{{ myLinksS3URL }}frontend/presentation6/images/wifi_one.png"
            alt="image"
          />
        </div>
        <h1 data-aos="fade-up-right">
          The choices you make will define your future!
        </h1>
        <h6 data-aos="fade-up-left">NOW YOU JUST HAVE TWO OPTIONS:</h6>
        <p>
          Make the wisest possible decision and welcome the financial flow for
          life.
        </p>
        <div class="option_main_box">
          <div class="option_left_box" data-aos="fade-right">
            <p>
              You can wait for the business to launch. You can select a business
              package for $25 and become a founder. However, this 'founder'
              position depends on the availability of the spots.
            </p>
          </div>
          <div class="option_right_box" data-aos="fade-left">
            <p>
              Request a Founders position NOW for a 90% discounted one-time fee
              of $97 to join the 1% at the top before the entire market joins.
              HIGHLY RECOMMENDED!
            </p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-6">
          <div class="sec_two_left_box" data-aos="fade-up-right">
            <h1>Design your Financial portfolio With minimum efforts</h1>
            <p>
              Purchase a spot at the discounted rate and follow all the
              suggestions by Mr.Ash Mufareh and you will be guided to the top.
              Real and sustainable products made up of smoothly-integrated
              technology.
            </p>
            <div class="clearfix"></div>
            <a
              [routerLink]="'.'"
              [queryParams]="{ reg: referralId }"
              [fragment]="'regform'"
            >
              <div class="become_button_one">BECOME A FOUNDER NOW</div>
            </a>
          </div>
        </div>
        <div class="col-lg-6 col-md-6">
          <div class="sec_two_right_box" data-aos="zoom-in">
            <div class="sec_two_right_box_image">
              <img
                src="{{ myLinksS3URL }}frontend/presentation6/images/image.png"
                alt="image"
              />
            </div>
            <div class="sec_two_video_image">
              <a
                href="#"
                data-toggle="modal"
                data-backdrop="static"
                data-keyboard="false"
                data-target="#myModal3"
                ><img
                  src="{{
                    myLinksS3URL
                  }}frontend/presentation6/images/video_image.png"
                  alt="video"
              /></a>
            </div>
          </div>
        </div>
      </div>
      <div class="reg_box">
        <h1 data-aos="fade-up">REGISTER WITH US IN THESE 3 STEPS</h1>
        <span class="top_line"></span>
        <div class="row">
          <div class="col-lg-4 col-md-4 col-sm-4">
            <div class="reg_first_box" data-aos="fade-right">
              <img
                src="{{
                  myLinksS3URL
                }}frontend/presentation6/images/cloud_image.png"
                alt="image"
              />
              <div class="reg_first_text_box">
                Fill out the form that requires only the basic information
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4">
            <div class="reg_first_box" data-aos="fade-left">
              <img
                src="{{
                  myLinksS3URL
                }}frontend/presentation6/images/cloud_image.png"
                alt="image"
              />
              <div class="reg_first_text_box">
                Make the payments through a gateway of your choice
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4">
            <div class="reg_first_box" data-aos="fade-up">
              <img
                src="{{
                  myLinksS3URL
                }}frontend/presentation6/images/cloud_image.png"
                alt="image"
              />
              <div class="reg_first_text_box">
                Get confirmation from our support team instantly
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="webiner_box">
        <div class="col-lg-5 col-md-5">
          <div class="webiner_left_box" data-aos="fade-right">
            <h1>WEBINAR</h1>

            <!-- <div class="play_back_button">
          
              <a href="#" data-aos="zoom-in" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#previous" >
              <img src="{{ myLinksS3URL }}frontend/presentation6/images/play_button.png" alt="image">
              </a>
              PREVIOUS WEBINAR PLAYBACK
           
          </div> -->

            <a
              href="#"
              class="play_back_button"
              data-aos="zoom-in"
              data-toggle="modal"
              data-backdrop="static"
              data-keyboard="false"
              data-target="#previous"
            >
              <img
                src="{{
                  myLinksS3URL
                }}frontend/presentation6/images/play_button.png"
                alt="image"
              />
              PREVIOUS WEBINAR PLAYBACK
            </a>

            <a
              [routerLink]="'.'"
              [queryParams]="{ reg: referralId }"
              [fragment]="'regform'"
            >
              <div class="become_button_two">BECOME A FOUNDER NOW</div>
            </a>
          </div>
        </div>
        <div class="col-lg-7 col-md-7">
          <div class="webiner_right_box" data-aos="fade-left">
            <img
              src="{{
                myLinksS3URL
              }}frontend/presentation6/images/web_image.jpg"
              alt="image"
            />
          </div>
        </div>
      </div>
      <div class="testimonilas_box">
        <div class="row">
          <div class="col-lg-5 col-md-5">
            <div class="test_left_box">
              <img
                src="{{
                  myLinksS3URL
                }}frontend/presentation6/images/testimonial_img.jpg"
                alt="image"
              />
            </div>
          </div>
          <div class="col-lg-7 col-md-7">
            <div class="test_right_box">
              <div class="testimonial-container">
                <div class="dk-container">
                  <div class="cd-testimonials-wrapper cd-container">
                    <h2>Testimonials</h2>
                    <ul class="cd-testimonials">
                      <owl-carousel-o [options]="customOptions">
                        <ng-template carouselSlide class="slider-item">
                          <li>
                            <div class="testimonial-content">
                              <h4>An ideal model for anyone</h4>
                              <div class="cd-author">
                                <img
                                  src="{{ cloudFrontUrl }}uploads/t1.png"
                                  alt="Author image"
                                />
                              </div>
                              <p>
                                His drive and passion for creating a platform to
                                help everyone from seasoned marketers to the
                                "little guy" helped solidify my belief Then
                                learning how we benefit financially with
                                optional starting points, makes this an ideal
                                model for anyone with a business who needs
                                advertising.
                              </p>

                              <p>
                                Thank you Ash for your vision and help for so
                                many people around the world.
                              </p>
                              <ul class="cd-author-info">
                                <li>Tim <strong>Leach</strong></li>
                                <li></li>
                              </ul>
                            </div>
                          </li>
                        </ng-template>
                        <ng-template carouselSlide class="slider-item">
                          <li>
                            <div class="testimonial-content">
                              <h4>This Will Undoubtedly Change Your Life!</h4>
                              <div class="cd-author">
                                <img
                                  src="{{ cloudFrontUrl }}uploads/t4.png"
                                  alt="Author image"
                                />
                              </div>
                              <p>
                                I want to personally say thank you to everyone
                                on this awesome journey that Ash Murareh has
                                created. As many of you may not know, Ash is a
                                very successful online marketer and has made his
                                living in this industry building massive teams
                                for various companies. He saw a big need for
                                creating a company that would help the average
                                person succeed online so he decided to build it
                                himself.
                              </p>

                              <p>
                                When you listen to his Founder's presentations
                                or when you speak with him, you will immediately
                                feel his passion to build a highly effective
                                business where every single person will be
                                successful.
                              </p>
                              <ul class="cd-author-info">
                                <li>Mike <strong>Williams</strong></li>
                                <li></li>
                              </ul>
                            </div>
                          </li>
                        </ng-template>
                        <ng-template carouselSlide class="slider-item">
                          <li>
                            <div class="testimonial-content">
                              <h4>
                                I AM TOTALLY BLOWN AWAY AND WILL BUILD MY FINAL
                                DYNASTY HERE IN ON PASSIVE
                              </h4>
                              <div class="cd-author">
                                <img
                                  src="{{ cloudFrontUrl }}uploads/t2.png"
                                  alt="Author image"
                                />
                              </div>
                              <p>
                                In my 19 years successful career in this space,I
                                have never seen a business so full, so
                                disruptive, so intriguing that everyone I
                                approach is excited to belong.
                              </p>
                              <p>
                                Did a Facebook post, alongside my WhatsApp
                                campaign, on the founder position, that
                                attracted 122 comments, 14 people have joined
                                direct to me and in less than 48 hours, 59 super
                                qualified leads have submitted their email,
                                requesting information to be founders, AND ALL
                                THESE WITHOUT ANYTHING YET ONGROUND, not even a
                                website. I am totally blown away and will build
                                my final dynasty here in ONPASSIVE.
                              </p>
                              <ul class="cd-author-info">
                                <li>PRINCE <strong>OBI</strong></li>
                                <li></li>
                              </ul>
                            </div>
                          </li>
                        </ng-template>
                      </owl-carousel-o>
                    </ul>
                  </div>
                  <!-- cd-testimonials -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form_bottom_box" id="regform">
        <div class="row">
          <div class="col-lg-5 col-md-5">
            <div class="left_botom_box">
              <img
                src="{{
                  myLinksS3URL
                }}frontend/presentation6/images/bottom_line.png"
                alt="image"
              />
              <h1>WELCOME<span class="d-block">O-Founders</span></h1>
              <p>
                Equally impressive is that we are 100% debt-free! Think about
                that for a moment. We have real and sustainable products made up
                of smoothly-integrated components and never-before-seen
                technology that run very smoothly together.
              </p>
              <h6>Already a Founder?</h6>
              <a routerLink="/auth/login" target="_blank" rel="noopener">
                <div class="sign_in_buton">SIGN IN</div>
              </a>
            </div>
          </div>
          <div class="col-lg-7 col-md-7">
            <div class="right_botom_box">
              <div class="form_box" id="reg_form">
                <div class="panel-group cst"></div>

                <form [formGroup]="registerForm">
                  <div class="row reg">
                    <div class="col-md-6">
                      <div class="d-block form-group">
                        <mat-label>First Name</mat-label>
                        <input
                          matInput
                          type="text"
                          class="log_in_fild"
                          placeholder="First Name"
                          formControlName="firstname"
                          required
                        /><br />
                        <span
                          *ngIf="
                            registerForm.controls['firstname'].hasError(
                              'required'
                            ) && registerForm.controls['firstname'].touched
                          "
                          class="failed-validation"
                          style="color: red"
                        >
                          First Name Required.
                        </span>
                        <span
                          *ngIf="
                            registerForm.controls['firstname'].hasError(
                              'maxlength'
                            )
                          "
                          class="failed-validation"
                          style="color: red"
                        >
                          Min 1, max 50 characters.
                        </span>

                        <span
                          *ngIf="
                            registerForm.controls['firstname'].hasError(
                              'containOnlyNumbers'
                            )
                          "
                          class="failed-validation"
                          style="color: red"
                        >
                          Only numbers are not allowed.
                        </span>

                        <span
                          *ngIf="
                            registerForm.controls['firstname'].hasError(
                              'containOnlySpecialChars'
                            )
                          "
                          class="failed-validation"
                          style="color: red"
                        >
                          Only special characters are not allowed.
                        </span>

                        <span
                          *ngIf="
                            registerForm.controls['firstname'].hasError(
                              'containConsecutiveSpaces'
                            )
                          "
                          class="failed-validation"
                          style="color: red"
                        >
                          Consecutive spaces are not allowed.
                        </span>

                        <span
                          *ngIf="
                            registerForm.controls['firstname'].hasError(
                              'containConsecutiveDots'
                            )
                          "
                          class="failed-validation"
                          style="color: red"
                        >
                          Consecutive dots are not allowed.
                        </span>

                        <span
                          *ngIf="
                            registerForm.controls['firstname'].hasError(
                              'containConsecutiveHyphens'
                            )
                          "
                          class="failed-validation"
                          style="color: red"
                        >
                          Consecutive dashes are not allowed.
                        </span>

                        <span
                          *ngIf="
                            registerForm.controls['firstname'].hasError(
                              'containConsecutiveUnderScores'
                            )
                          "
                          class="failed-validation"
                          style="color: red"
                        >
                          Consecutive underscores are not allowed.
                        </span>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="d-block form-group">
                        <mat-label>Last Name</mat-label>
                        <input
                          matInput
                          type="text"
                          placeholder="Last Name"
                          class="log_in_fild"
                          formControlName="lastname"
                          required
                        />
                        <span
                          *ngIf="
                            registerForm.controls['lastname'].hasError(
                              'required'
                            ) && registerForm.controls['lastname'].touched
                          "
                          class="failed-validation"
                          style="color: red"
                        >
                          Last Name Required.
                        </span>
                        <span
                          *ngIf="
                            registerForm.controls['lastname'].hasError(
                              'maxlength'
                            )
                          "
                          class="failed-validation"
                          style="color: red"
                        >
                          Min 1, max 50 characters.
                        </span>
                        <span
                          *ngIf="
                            registerForm.controls['lastname'].hasError(
                              'containOnlyNumbers'
                            )
                          "
                          class="failed-validation"
                          style="color: red"
                        >
                          Only numbers are not allowed.
                        </span>
                        <span
                          *ngIf="
                            registerForm.controls['lastname'].hasError(
                              'containOnlySpecialChars'
                            )
                          "
                          class="failed-validation"
                          style="color: red"
                        >
                          Only special characters are not allowed.
                        </span>
                        <span
                          *ngIf="
                            registerForm.controls['lastname'].hasError(
                              'containConsecutiveSpaces'
                            )
                          "
                          class="failed-validation"
                          style="color: red"
                        >
                          Consecutive spaces are not allowed.
                        </span>
                        <span
                          *ngIf="
                            registerForm.controls['lastname'].hasError(
                              'containConsecutiveDots'
                            )
                          "
                          class="failed-validation"
                          style="color: red"
                        >
                          Consecutive dots are not allowed.
                        </span>
                        <span
                          *ngIf="
                            registerForm.controls['lastname'].hasError(
                              'containConsecutiveHyphens'
                            )
                          "
                          class="failed-validation"
                          style="color: red"
                        >
                          Consecutive dashes are not allowed.
                        </span>
                        <span
                          *ngIf="
                            registerForm.controls['lastname'].hasError(
                              'containConsecutiveUnderScores'
                            )
                          "
                          class="failed-validation"
                          style="color: red"
                        >
                          Consecutive underscores are not allowed.
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="d-block form-group">
                        <mat-label>Phone number</mat-label>
                        <input
                          matInput
                          type="text"
                          placeholder="Phone Number"
                          class="log_in_fild"
                          formControlName="phone"
                          onKeyPress="if(this.value.length==20) return false;"
                          onkeydown="return event.keyCode !== 69"
                          required
                        />
                        <span
                          *ngIf="
                            registerForm.controls['phone'].hasError(
                              'required'
                            ) && registerForm.controls['phone'].touched
                          "
                          class="failed-validation"
                          style="color: red"
                        >
                          Phone number is required.
                        </span>
                        <span
                          *ngIf="
                            registerForm.controls['phone'].hasError('pattern')
                          "
                          class="failed-validation"
                          style="color: red"
                        >
                          Only numbers are allowed.
                        </span>
                        <span
                          *ngIf="
                            registerForm.controls['phone'].hasError(
                              'minlength'
                            ) ||
                            registerForm.controls['phone'].hasError('maxlength')
                          "
                          class="failed-validation"
                          style="color: red"
                        >
                          Min 6 and max 20 digits.
                        </span>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="d-block form-group">
                        <mat-label>Email</mat-label>
                        <input
                          matInput
                          type="text"
                          placeholder="Email Address"
                          class="log_in_fild"
                          formControlName="email"
                          required
                        />

                        <span
                          *ngIf="
                            registerForm.controls['email'].hasError(
                              'required'
                            ) && registerForm.controls['email'].touched
                          "
                          class="failed-validation"
                          style="color: red"
                        >
                          Email id Required.
                        </span>
                        <span
                          *ngIf="
                            registerForm.controls['email'].hasError('pattern')
                          "
                          class="failed-validation"
                          style="color: red"
                        >
                          Please enter valid email.
                        </span>
                        <!-- <span *ngIf="registerForm.controls['email'].hasError('maxLength')" 
                                       class="failed-validation" style="color: red">
                                        Email length sould be less than 100.
                                      </span>-->
                      </div>
                    </div>
                  </div>

                  <div class="form-group d-block">
                    <mat-label>Password</mat-label>
                    <div class="password-block">
                      <input
                        matInput
                        placeholder="Password"
                        formControlName="password"
                        class="log_in_fild"
                        [type]="pwdToggle ? 'text' : 'password'"
                        required
                      />
                      <button
                        type="button"
                        class="password-icon"
                        (click)="pwdToggle = !pwdToggle"
                      >
                        <i
                          class="fal"
                          [ngClass]="{
                            'fa-eye': pwdToggle,
                            'fa-eye-slash': !pwdToggle
                          }"
                        ></i>
                      </button>
                    </div>
                    <span
                      *ngIf="
                        registerForm.controls['password'].hasError(
                          'required'
                        ) && registerForm.controls['password'].touched
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Password Required
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['password'].hasError('pattern')
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Password should contain minimum 8 Characters and Atleast
                      one Uppercase, One Lowercase, one Number and one Special
                      Characters
                    </span>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="d-block form-group">
                        <mat-label>Country</mat-label>
                        <mat-select
                          formControlName="country_id"
                          required
                          class="log_in_fild"
                        >
                          <mat-option value="">Select Country</mat-option>
                          <mat-option
                            *ngFor="let country of countriesList"
                            [value]="country.countryId"
                          >
                            {{ country.countryName }}
                          </mat-option>
                        </mat-select>
                        <span
                          *ngIf="
                            registerForm.controls['country_id'].hasError(
                              'required'
                            ) && registerForm.controls['country_id'].touched
                          "
                          class="failed-validation"
                          style="color: red"
                        >
                          Plese Select Country
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="text-center">
                    <button
                      mat-raised-button
                      type="submit"
                      (click)="submitRegister()"
                      [disabled]="registerForm.invalid"
                      class="ibtn w-100"
                    >
                      SignUp
                    </button>
                  </div>
                </form>
              </div>
              <div class="envolop_image">
                <img
                  src="{{
                    myLinksS3URL
                  }}frontend/presentation6/images/envolop_image.png"
                  alt="image"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="footer">
    <div class="container">
      Copyright &copy; 2022 All rights reserved | by O-Founders
    </div>
  </div>

  <!-- Modal -->

  <div id="myModal4" class="modal fade" role="dialog">
    <div class="modal-dialog modal-lg">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            id="fourth_video_pause"
            class="close"
            data-dismiss="modal"
            (click)="video1.pause(); video1.currentTime = 0"
          >
            &times;
          </button>
        </div>
        <video
          #video1
          id="my-video"
          class="video-js"
          controls
          preload="auto"
          poster="{{ myLinksS3URL }}frontend/invitationfive/images/poster.png"
        >
          <source
            src="{{ myLinksS3URL }}videos/Invite_Video_0104.mp4"
            type="video/mp4"
          />
          <p class="vjs-no-js">
            To view this video please enable JavaScript, and consider upgrading
            to a web browser that
            <a
              href="https://videojs.com/html5-video-support/"
              target="_blank"
              rel="noopener"
              >supports HTML5 video</a
            >
          </p>
        </video>
      </div>
    </div>
  </div>
  <div id="myModal1" class="modal fade" role="dialog">
    <div class="modal-dialog modal-lg">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            id="first_video_pause"
            class="close"
            data-dismiss="modal"
            (click)="video2.pause(); video2.currentTime = 0"
          >
            &times;
          </button>
        </div>
        <video
          #video2
          id="my-video"
          class="video-js"
          controls
          preload="auto"
          poster="{{
            myLinksS3URL
          }}frontend/invitationfive/images/greeting1-new.png"
        >
          <source
            src="{{ myLinksS3URL }}videos/video1-compressed-new.mp4"
            type="video/mp4"
          />
          <p class="vjs-no-js">
            To view this video please enable JavaScript, and consider upgrading
            to a web browser that
            <a
              href="https://videojs.com/html5-video-support/"
              target="_blank"
              rel="noopener"
              >supports HTML5 video</a
            >
          </p>
        </video>
      </div>
    </div>
  </div>
  <div id="myModal2" class="modal fade" role="dialog">
    <div class="modal-dialog modal-lg">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            id="second_video_pause"
            class="close"
            data-dismiss="modal"
            (click)="video3.pause(); video3.currentTime = 0"
          >
            &times;
          </button>
        </div>
        <video
          #video3
          id="my-video1"
          class="video-js"
          controls
          preload="auto"
          poster="{{
            myLinksS3URL
          }}frontend/greetingsgofound/images/greeting2.png"
        >
          <source
            src="{{ myLinksS3URL }}videos/Video2-Compressed-new.mp4"
            type="video/mp4"
          />
          <p class="vjs-no-js">
            To view this video please enable JavaScript, and consider upgrading
            to a web browser that
            <a
              href="https://videojs.com/html5-video-support/"
              target="_blank"
              rel="noopener"
              >supports HTML5 video</a
            >
          </p>
        </video>
      </div>
    </div>
  </div>
  <div id="myModal3" class="modal fade" role="dialog">
    <div class="modal-dialog modal-lg">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            id="third_video_pause"
            class="close"
            data-dismiss="modal"
            (click)="video4.pause(); video4.currentTime = 0"
          >
            &times;
          </button>
        </div>
        <video
          #video4
          id="my-video2"
          class="video-js"
          controls
          preload="auto"
          poster="{{
            myLinksS3URL
          }}frontend/invitationfive/images/greeting3-new.png"
        >
          <source
            src="{{
              myLinksS3URL
            }}videos/ONPASSIVE-BUSINESS-PRESENTATION-BLESSYOURLOVEDONES.mp4"
            type="video/mp4"
          />
          <p class="vjs-no-js">
            To view this video please enable JavaScript, and consider upgrading
            to a web browser that
            <a
              href="https://videojs.com/html5-video-support/"
              target="_blank"
              rel="noopener"
              >supports HTML5 video</a
            >
          </p>
        </video>
      </div>
    </div>
  </div>
  <div id="book" class="modal fade" role="dialog">
    <div class="modal-dialog modal-sm modal-dialog-centered">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">
            &times;
          </button>
        </div>
        <div class="modal-body book-seat">
          <div class="card">
            <div class="card-body">
              <form>
                <div class="form-group">
                  <label>Full Name <span class="text-danger">*</span></label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Enter Full Name"
                  />
                </div>
                <div class="form-group">
                  <label
                    >Mobile Number <span class="text-danger">*</span></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Enter Mobile Number"
                  />
                </div>
                <div class="form-group">
                  <label
                    >Email Address <span class="text-danger">*</span></label
                  >
                  <input
                    type="email"
                    class="form-control"
                    placeholder="Enter Email Address"
                  />
                </div>
                <div class="form-group"></div>
                <button type="submit" class="btn btn-success btn-block">
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="previous" class="modal fade" role="dialog">
    <div class="modal-dialog modal-lg">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            id="prev_video_pause"
            (click)="video5.pause(); video5.currentTime = 0"
          >
            &times;
          </button>
        </div>
        <video
          #video5
          width="100%"
          class="video-js"
          controls
          preload="auto"
          poster="{{ myLinksS3URL }}videos/title.jpg"
          id="my-video"
        >
          <source
            src="{{
              myLinksS3URL
            }}videos/ONPASSIVE-BUSINESS-PRESENTATION-BLESSYOURLOVEDONES.mp4"
            id="video"
            type="video/mp4"
          />
          Your browser does not support HTML5 video.
        </video>
      </div>
    </div>
  </div>

  <div class="country_popup_wrapper"></div>
</div>
